import { getData, putData, deleteData } from "../apiClient";

// ─── Paginated list ───────────────────────────────────────────────────────────

export const getCommentsWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({ page: String(page), limit: String(limit), search });
        const result = await getData(`/blog-comment/?${queryParams}`, {}, {}, signal);
        return { success: true, ...result };
    } catch (error) {
        console.error("Get Blog Comments pagination API error:", error);
        return { success: false, ...error };
    }
};

// ─── Update status ────────────────────────────────────────────────────────────

export const updateCommentStatus = async ({ id, data }) => {
    try {
        const result = await putData(`/blog-comment/status/${id}`, data);
        return { data: { success: true, data: result } };
    } catch (error) {
        return { data: { success: false, error: error.message, status: error.status } };
    }
};

// ─── Delete ───────────────────────────────────────────────────────────────────

export const deleteComment = async ({ id }) => {
    try {
        const result = await deleteData(`/blog-comment/delete-comment/${id}`);
        return { data: { success: true, data: result } };
    } catch (error) {
        return { data: { success: false, error: error.message, status: error.status } };
    }
};
